import { useEffect } from "react";
import { CheckGreenIcon } from "../../assets/svgs";
import { FaEnvelope, FaEye, FaPaperPlane, FaIndustry } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { logout } from "../../api";
import { useUser } from "../../contexts";

const SuccessScreen = () => {
  const { t } = useTranslation();
  const [, dispatchUser] = useUser();
  useEffect(() => {
    // Hier wird die logout-Funktion beim Laden der Seite ausgeführt
    logout();
    dispatchUser({ type: "SIGN_OUT" });
  }, []); // Das leere Array stellt sicher, dass der Effekt nur einmal beim Laden der Seite ausgeführt wird
  return (
    <div className="sent-printdata">
      <CheckGreenIcon />
      <span>{t("sendSuccess")}</span>
      <p className="p-4">{t("thankYouForUploading")}</p>
      <FaEnvelope
        style={{
          paddingTop: "48px",
          width: "34px",
          height: "34px",
          flexShrink: 0,

        }}
      />
      <p style={{ paddingBottom: "64px" }} className="p-2">
        {t("recieveUpdates")}
      </p>
      <div
        style={{
          width: "100%",
          maxWidth: "457px",
          flexShrink: 0,
          borderRadius: "25px",
          background: "#FFF",
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.5)",

        }}
      >
        <p style={{ marginTop: "39px", fontWeight: 500, fontSize: "24px" }}>
          {t("happensNext")}
        </p>
        <FaEye
          style={{
            paddingTop: "48px",
            paddingBottom: "10px",
            width: "34px",
            height: "34px",
            flexShrink: 0,
            display: "block",
            margin: "auto",
          }}
        />
        <p style={{ fontSize: "12px" }}>{t("happensNextStep1")}</p>
        <p style={{ fontSize: "10px", paddingBottom: "24px" }}>{t("happensNextStep15")}</p>
        <FaEnvelope
          style={{
            paddingTop: "48px",
            paddingBottom: "10px",
            width: "34px",
            height: "34px",
            flexShrink: 0,
            display: "block",
            margin: "auto",
          }}
        />
        <p style={{ fontSize: "12px" }}>{t("happensNextStep2")}</p>
        <p style={{ fontSize: "10px", paddingBottom: "24px" }}>{t("happensNextStep25")}</p>
        <FaPaperPlane
          style={{
            paddingTop: "48px",
            paddingBottom: "10px",
            width: "34px",
            height: "34px",
            flexShrink: 0,
            display: "block",
            margin: "auto",
          }}
        />
        <p style={{ fontSize: "12px" }}>{t("happensNextStep3")}</p>
        <p style={{ fontSize: "10px", paddingBottom: "24px" }}>{t("happensNextStep35")}</p>
        <FaIndustry
          style={{
            paddingTop: "48px",
            paddingBottom: "10px",
            width: "34px",
            height: "34px",
            flexShrink: 0,
            display: "block",
            margin: "auto",
          }}
        />
        <p style={{ fontSize: "12px" }}>
          {t("happensNextStep4")}
        </p>
        <p style={{ fontSize: "10px", paddingBottom: "48px" }}>
          {t("happensNextStep45")}
        </p>
      </div>
    </div>
  );
};

export default SuccessScreen;
